import script from "./scene-mgmt-main.vue?vue&type=script&lang=ts&setup=true"
export * from "./scene-mgmt-main.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__